import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/owner-portal")({
  staticData: { title: "Owner Portal" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/owner-portal/page.tsx"),
    "OwnerPortal",
  ),
})
